export const MODAL_PING_OPEN = 'MODAL_PING_OPEN';
export const MODAL_PING_OPEN_RESULT = 'MODAL_PING_OPEN_RESULT';
export const MODAL_PING_CLOSE = 'MODAL_PING_CLOSE';

